import React, { useState } from "react"
import Layout from "../../components/layout"
import Image from "../../components/image"
import { AppendixWaypoint, Appendix } from "../../components/appendix"
import Hero from "../../components/hero"
import PeopleGrid from "../../components/people-grid"
import ReadNext from "../../components/read-next"

const PAGESLUG = "executive-directors-management-team"

function ManagementPhoto({ image, name, title, classes }) {
  return (
    <div
      className={
        classes ? `management-team__photo ${classes}` : `management-team__photo`
      }
    >
      <Image path={image} />
      <div className="management-team__photo__info">
        <div className="management-team__photo__info__title">{title}</div>
        <div className="management-team__photo__info__name">{name}</div>
      </div>
    </div>
  )
}

export default function IMFOrganizationChart() {
  const [peopleOverlayActive, setPeopleOverlayActive] = useState(false)
  const toggleOverlayVisibility = () => {
    setPeopleOverlayActive(!peopleOverlayActive)
  }

  return (
    <Layout>
      <section className="page page--pullBottom text-block page--margin-medium">
        <Hero title="Executive Directors & Management Team" />

        <section className="executive-directors">
          <div className="executive-directors__right">
            <h2 style={{ marginBottom: 5 }}>
              Executive Directors & Alternates
            </h2>
            <p className="title--s" style={{ marginBottom: 20 }}>
              <b>As of April 30, 2021</b>
            </p>
            <AppendixWaypoint page={PAGESLUG} id={1} />
            <p>
              <b>The Executive Board is responsible</b> for conducting the
              day-to-day business of the IMF. It is composed of 24 Executive
              Directors, who are elected by member countries or by groups of
              countries, and the Managing Director, who serves as its Chair.
            </p>
            <p>
              All IMF member countries are represented on its Executive Board,
              which discusses the national, regional, and global consequences of
              each member’s economic policies and approves IMF financing to help
              member countries address temporary balance of payments problems,
              as well as oversees the IMF’s capacity development efforts.
            </p>
            <button
              className="cta--primary"
              onClick={() => setPeopleOverlayActive(!peopleOverlayActive)}
            >
              View Executive Directors
            </button>
          </div>
          <div className="executive-directors__left">
            <PeopleGrid
              id="Executive Directors"
              overlayActive={peopleOverlayActive}
              toggleOverlayVisibility={toggleOverlayVisibility}
            />
          </div>
        </section>

        <section className="management-team">
          <div className="management-team__intro">
            <h2>Management Team</h2>
            <p>
              <b>The IMF has a Managing Director,</b> who is head of the staff
              and Chair of the Executive Board. The Managing Director is
              assisted by a First Deputy Managing Director and three other
              Deputy Managing Directors.
            </p>
          </div>

          <ManagementPhoto
            image="who-we-are/people/mitsuhiro-furusawa.jpg"
            name="Mitsuhiro Furusawa"
            title="Deputy Managing Director"
            classes="util__desktop-only"
          />

          <ManagementPhoto
            image="who-we-are/people/tao-zhang.jpg"
            name="Tao Zhang"
            title="Deputy Managing Director"
            classes="util__desktop-only"
          />

          <ManagementPhoto
            image="who-we-are/people/kristalina-georgieva.jpg"
            name="Kristalina Georgieva"
            title="Managing Director"
          />

          <ManagementPhoto
            image="who-we-are/people/geoffrey-okamoto.jpg"
            name="Geoffrey W.S. Okamoto"
            title="First Deputy Managing Director"
          />

          <ManagementPhoto
            image="who-we-are/people/antoinette-sayeh.jpg"
            name="Antoinette Sayeh"
            title="Deputy Managing Director"
          />

          <ManagementPhoto
            image="who-we-are/people/mitsuhiro-furusawa.jpg"
            name="Mitsuhiro Furusawa"
            title="Deputy Managing Director"
            classes="util__mobile-only"
          />

          <ManagementPhoto
            image="who-we-are/people/tao-zhang.jpg"
            name="Tao Zhang"
            title="Deputy Managing Director"
            classes="util__mobile-only"
          />
        </section>
      </section>

      <ReadNext sectionID="who-we-are" pageID="resources" />
      <Appendix page={PAGESLUG} />
    </Layout>
  )
}
